import { Permission }	from "@v3/data/permission";

export type GuiPermission	= Permission|GuiOnly;
export const GuiPermission	= {
	accessAllowed:	(available:ReadonlySet<Permission>, permission:GuiPermission):boolean	=>
					permission === GuiOnly ||
					available.has(permission),
};

/**
sentinel value acting as a special permission:
anyone can execute this, regardless of being logged in or having any roles
*/
export const GuiOnly:unique symbol	= Symbol("GuiOnly");
export type GuiOnly					= typeof GuiOnly;
